import { FC, useCallback } from 'react';
import { useTranslation } from 'common/hooks/useTranslation';
import { toast } from 'react-toastify';
import { Button, CircularProgress } from '@mui/material';
import { useManualCacheData } from 'app/installation/hooks/useManualCacheData';

import { styles } from './CacheDataButton.styles';

export type CacheDataButtonProps = {
  propertyId: number | null;
};

export const CacheDataButton: FC<CacheDataButtonProps> = ({ propertyId }) => {
  const { t } = useTranslation();
  const { cacheData, isCaching } = useManualCacheData(propertyId);

  const handleClick = useCallback(async () => {
    try {
      const result = await cacheData();
      if (result?.hasFailures) {
        toast.error(t('cache.error'));
      } else {
        toast.success(t('cache.success'));
      }
    } catch {
      toast.error(t('cache.error'));
    }
  }, [cacheData, t]);

  return (
    <Button
      variant="contained"
      fullWidth
      disabled={isCaching}
      sx={!isCaching ? styles.button : {}}
      onClick={handleClick}
      data-cy="cache-data-button"
    >
      {isCaching ? <CircularProgress size={16} /> : t('cache.trigger')}
    </Button>
  );
};
